export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo-link",
  link: (id) => `nav-link-${id}`,
  cta: "nav-cta-proposal",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  ctaProposal: "hero-cta-proposal",
  ctaServices: "hero-cta-services",
  scrollHint: "hero-scroll-hint",
};

export const CONTACT_FORM = {
  root: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  company: "contact-input-company",
  phone: "contact-input-phone",
  message: "contact-input-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const PROPOSAL = {
  root: "proposal-form",
  step: (n) => `proposal-step-${n}`,
  next: "proposal-next",
  back: "proposal-back",
  submit: "proposal-submit",
  success: "proposal-success",
  field: (name) => `proposal-field-${name}`,
  serviceChip: (id) => `proposal-service-${id}`,
};

export const ADMIN = {
  emailInput: "admin-login-email",
  passwordInput: "admin-login-password",
  submit: "admin-login-submit",
  error: "admin-login-error",
  logout: "admin-logout",
  tabContacts: "admin-tab-contacts",
  tabProposals: "admin-tab-proposals",
  contactsTable: "admin-contacts-table",
  proposalsTable: "admin-proposals-table",
  row: (id) => `admin-row-${id}`,
};
